module.exports = __webpack_public_path__ + "static/img/电影福利-主图@2x.b38f974.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/电影福利-主图@2x.png
// module id = 0EHo
// module chunks = 1